import { Button, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { dispatchReminderEmail } from '../../redux/slice/organization-dashboard/organization-api';
import {
  OrganizationProps,
  PreEmploymentUserData,
} from '../../redux/slice/organization-dashboard/organization.types';
import { fetchPreEmployment } from '../../redux/slice/organization-dashboard/organizationthunk';
import { AppDispatch, RootState } from '../../redux/store';
import logger from '../../services/logger';
import { GenericDataTable } from '../common/GenericDataTable';

export const PreEmploymentStats: React.FC<OrganizationProps> = ({ orgnizationId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { preEmployment, preEmploymentLoader } = useSelector(
    (state: RootState) => state.organizationDashboard,
  );
  const [filters, setFilters] = useState({
    name: '',
    email: '',
  });

  const [emailLoader, setEmailLoader] = useState(false);
  useEffect(() => {
    if (orgnizationId) {
      void dispatch(fetchPreEmployment({ organizationId: orgnizationId, limit: limit }));
    }
  }, [dispatch, orgnizationId, filters]);

  const userData: PreEmploymentUserData[] = preEmployment?.employeeData ?? [];

  const limit = 100; // Adjust as needed

  const handleFilterChange = (newFilters: Record<string, string>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  const filteredData = userData.filter((user) => {
    return (
      (!filters.name || user?.name?.toLowerCase().includes(filters.name)) &&
      (!filters.email || user?.email?.toLowerCase().includes(filters.email))
    );
  });

  const handleButtonClick = async (user: { name: string; email: string }) => {
    try {
      setEmailLoader(true);
      if (user) {
        const sendEmail = await dispatchReminderEmail(user);
        if (sendEmail?.status == 200) {
          toast.success(`Email sent to ${user.email}`);
        }
      }
    } catch (error) {
      toast.error('Something went wrong...');

      logger.error('error:', error);
    } finally {
      setEmailLoader(false);
    }
  };

  const preEmploymentColumns = [
    { label: 'Name', accessor: 'name' },
    { label: 'Email', accessor: 'email' },
    { label: 'Intake', accessor: 'intake' },
    { label: 'Employment Readiness', accessor: 'employmentReadiness' },
    { label: 'Skills', accessor: 'skills' },
    { label: 'Career Readiness', accessor: 'careerReadiness' },
    { label: 'Experience', accessor: 'expirence' },
    {
      label: 'Send Email', // Add button column
      accessor: 'action',
      Cell: (row: { name: string; email: string }) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onClick={() => handleButtonClick(row)} // Button click event
        >
          Reminder
        </Button>
      ),
    },
    { label: 'Registration Date', accessor: 'createdAt' },
  ];

  return (
    <>
      <Typography
        variant="h6"
        fontWeight="bold"
        className="border-purple-900 border-b-2 rounded-lg  mb-4 mt-4 text-purple-700 "
        gutterBottom
      >
        Pre-Employment Data (% completed)
      </Typography>
      <GenericDataTable
        isLoading={preEmploymentLoader}
        columns={preEmploymentColumns}
        data={filteredData}
        filterFields={[
          { name: 'name', label: 'Filter by Name' },
          { name: 'email', label: 'Filter by Email' },
        ]}
        onFilterChange={handleFilterChange}
        ctaLoader={emailLoader}
      />
    </>
  );
};
